<template>
  <div class="home">
    <div class="header">
      <div class="tou">
        <div class="logo">
          <div class="logoImg"><img src="../assets/ws_Logo.png" alt="" /></div>
          <div class="tit">广州大糖智能科技有限公司</div>
        </div>
        <div class="list">
          <ul>
            <li
              :class="[
                index == idx
                  ? 'list_line'
                  : item.text == '(登录)'
                  ? 'login'
                  : '',
              ]"
              @click="go(item.url, index)"
              v-for="(item, index) in list"
              :key="index"
            >
              <div>{{ item.text }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <router-view />
    <div class="footer">
      <img src="../assets/footer.datang.png" alt="" />
    </div>

    
  </div>
</template>

<script>
export default {
  data() {
    // Journalism    Product   AboutUs
    return {
      idx: 0,
      list: [
        {
          text: "首页",
          url: "/index",
        },
        {
          text: "产品介绍",
          url: "/Product",
        },
        {
          text: "新闻动态",
          url: "/Journalism",
        },
        {
          text: "运营后台",
          url: "/Operation",
        },
        {
          text: "(登录)",
          url: "",
        },

        {
          text: "关于我们",
          url: "/AboutUs",
        },
      ],
    };
  },
  created() {
    if (sessionStorage.getItem("index")) {
      this.idx = sessionStorage.getItem("index");
    }
  },
  methods: {
    go(url, index) {
      console.log(index);
      if (index == 4) {
        location.href =
          "http://terminal.dingyou168.com/mobile1.0/index.html#/login";
      } else {
        sessionStorage.setItem("index", index);
        this.idx = index;
      }

      this.$router.push(url);
      if (url == "/index") {
        location.reload();
      }
    },
  },
};
</script>

<style scoped lang='less'>
img {
  vertical-align: top;
}
.login {
  color: #fff;
  font-size: 16px !important;
  margin-left: 2px !important;
}
.home {
  width: 100%;
  // background: linear-gradient(90deg, #dbf0fb 0%, #e9e8fd 60%, #ddf0fd 100%);
  .header {
    height: 74px;
    line-height: 74px;
    font-size: 28px;
    text-align: center;
    position: sticky;
    top: 0;
    position: -webkit-sticky;
    position: -moz-sticky;
    position: -ms-sticky;
    position: -o-sticky;
    .tou {
      display: flex;
      height: 74px;
      background: #07102f;
      .logo {
        background: #07102f;
        display: flex;
        align-items: center;
        .tit {
          color: #fff;
          font-weight: 700;
        }
        .logoImg {
          width: 30px;
          height: 30px;
          overflow: hidden;
          border-radius: 50%;
          margin: 0 5px 0 440px;
          img {
            width: 100%;
            height: 100%;
            background: #fff;
          }
        }
      }
      .list {
        margin-left: 300px;
        background: #07102f;
        color: #fff;
        ul {
          display: flex;
          font-size: 22px !important;
          li {
            margin-left: 20px;
            font-size: 22px;
          }
        }
      }
    }
  }
  .list_line {
    color: #ff3333;
  }
  .ws_SX {
    width: 100%;
    height: 700px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .footer {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>